import React, { useEffect } from "react";
import { useLang } from "../contexts/LanguageContext";

export default function LegalPage({ kind }) {
  const { t } = useLang();
  const c = t.legal[kind];

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${c.title} · Agrovalor Ibérica`;
  }, [c.title]);

  return (
    <main data-testid={`legal-${kind}-page`} className="pt-32 pb-24">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <div className="flex items-start gap-4 mb-10">
          <span className="block h-px w-12 bg-terracotta mt-3" aria-hidden />
          <span className="eyebrow">{t.footer.legal}</span>
        </div>
        <h1 className="h-section text-olive mb-10">{c.title}</h1>
        <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-olive-soft mb-12">
          {c.updatedLabel}: {c.updatedAt}
        </div>
        <div className="flex flex-col gap-10">
          {c.sections.map((s, i) => (
            <section key={i} data-testid={`legal-${kind}-section-${i}`}>
              <h2 className="font-display text-xl sm:text-2xl text-olive mb-3">{s.title}</h2>
              <p className="text-base text-olive-soft leading-relaxed whitespace-pre-line">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
